<script lang="ts">
  import { onMount } from "svelte";
  import { _ as t } from "svelte-i18n";
  import { bridge } from "./lib/bridge";
  import NavBar from "../libs/components/NavBar.svelte";
  import { isEmbedded } from "../libs/chief-bridge";
  import { supportsShare } from "./lib/version";
  import Home from "./pages/Home.svelte";
  import Rules from "./pages/Rules.svelte";
  import WeChatMask from "./components/WeChatMask.svelte";
  import lineShareIcon from "./assets/images/ui/share.png";

  const showShare = supportsShare();
  const embedded = isEmbedded();

  // ?rules=true 进规则页，前进后退由 popstate 驱动
  let isRulesPage = $state(
    new URLSearchParams(window.location.search).get("rules") === "true",
  );

  /** 微信内打开时显示提示遮罩 */
  let showWeChatMask = $state(false);

  /** 判断是否在微信内打开 */
  function isWeChat(): boolean {
    return /micromessenger/i.test(navigator.userAgent.toLowerCase());
  }

  function syncPageState() {
    isRulesPage =
      new URLSearchParams(window.location.search).get("rules") === "true";
  }

  // 必须与构建产物路径（dist/lottery-anniversary）一致，否则微信抓不到 index.html 的标题
  const shareUrl =
    __MODE__ === "prod"
      ? "https://common-h5.chiefgroup.com.hk/lottery-anniversary/"
      : "https://common-h5.test.stx365.com/lottery-anniversary/";

  function handleClose() {
    bridge.send("Route_HomePage");
  }

  function handleShare() {
    bridge.send("share", {
      title: $t("title"),
      shareContentText: shareUrl,
    });
  }

  onMount(() => {
    bridge.send("Send_Title_To_App", { title: $t("title") });
    window.addEventListener("popstate", syncPageState);

    // 站外且在微信内打开时，显示提示遮罩
    if (!embedded && isWeChat()) {
      showWeChatMask = true;
    }
    // if (!embedded) {
    //   showWeChatMask = true; // 调试：始终显示
    // }
    return () => window.removeEventListener("popstate", syncPageState);
  });
</script>

<svelte:head>
  <title>{$t("title")}</title>
</svelte:head>

{#if isRulesPage}
  <Rules />
{:else}
  <NavBar
    title=""
    onClose={handleClose}
    bgOpacity={0}
    lightBgColor="#0E2C8C"
    lightTextColor="#ffffff"
    darkBgColor="#0E2C8C"
    darkTextColor="#ffffff"
    disableOffsetUp={true}
  >
    {#snippet right()}
      {#if showShare}
        <!-- NavBar 高度是固定 px，分享按钮用内联样式避免被 px2rem 放大 -->
        <button
          type="button"
          class="flex items-center justify-center"
          style="width: 32px; height: 32px;"
          onclick={handleShare}
        >
          <img
            src={lineShareIcon}
            alt="share"
            style="width: 20px; height: 20px;"
          />
        </button>
      {/if}
    {/snippet}

    <Home />
  </NavBar>
{/if}

<!-- 微信内打开时的提示遮罩 -->
<WeChatMask show={showWeChatMask} onClose={() => (showWeChatMask = false)} />
